<div class="loginPage">
    <div class="language-switcher-container">
        <app-language-switcher></app-language-switcher>
    </div>
    <form (ngSubmit)="onSubmit()" #form="ngForm">
        <div class="container">
            <div class="form">
                <div class="portalLogo" (click)="gotoHome()" style="cursor: pointer;" title="Home"></div>
                <div class="text-center">
                    <h2>{{ _translateService.Keys.LOGIN_TITLE | translate }}</h2>
                </div>
                <div *ngIf="isLoginError" class="error_mess">
                    <p>{{ _translateService.Keys.LOGIN_INVALID_CREDENTIALS | translate }}</p>
                </div>
                <div class="form-group">
                    <input
                        class="form-input"
                        name="email"
                        type="email"
                        id="login-input"
                        placeholder="{{ _translateService.Keys.LOGIN_EMAIL_ADDRESS | translate }}"
                        [(ngModel)]="email"
                        #emailInput="ngModel"
                        autocomplete="email"
                        required
                    />
                    <label for="login-input" class="form_label">
                        {{ _translateService.Keys.LOGIN_EMAIL_ADDRESS | translate }}
                    </label>
                    <div *ngIf="form.submitted && emailInput.invalid" class="alert alert-danger">
                        <span>{{ _translateService.Keys.LOGIN_ENTER_VALID_EMAIL | translate }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <input
                        class="form-input"
                        name="password"
                        type="password"
                        id="password-input"
                        placeholder="{{ _translateService.Keys.LOGIN_PASSWORD | translate }}"
                        [(ngModel)]="password"
                        #passwordInput="ngModel"
                        autocomplete="current-password"
                        minlength="6"
                        required
                    />
                    <label for="password-input" class="form_label">
                        {{ _translateService.Keys.LOGIN_PASSWORD | translate }}
                    </label>
                    <div *ngIf="form.submitted && passwordInput.invalid" class="alert alert-danger">
                        <span>{{ _translateService.Keys.LOGIN_ENTER_PASSWORD | translate }}</span>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="forgot" [ngClass]="{'col-md-12' : isSubmit, 'col-md-8' : !isSubmit}">
                        <a [routerLink]="['/forgot-password']">
                            {{ _translateService.Keys.LOGIN_FORGOT_PASSWORD | translate }}
                        </a>
                    </div>
                    <div class="col-md-4" *ngIf="!isSubmit">
                        <button type="submit" class="primary-button" id="login-button">
                            {{ _translateService.Keys.LOGIN_LOGIN_BUTTON | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <div class="login-footer mt-4 text-center">
        <a 
            [href]="'mailto:'+ mainEmail +'?cc=' + supportEmail"
            class="footer-link"
        >
            {{ _translateService.Keys.LOGIN_GL_QUOTE | translate }}
        </a>
        <a 
            href="https://my.suedvers.de/afp/login.html"
            target="_blank"
            class="footer-link"
        >
            Claims Reporting
        </a>
        <a 
            [href]="'mailto:' + supportEmail"
            class="footer-link"
        >
            {{ _translateService.Keys.COMMON_CONTACT_US | translate }}
        </a>
    </div>

</div>
